import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import useWakeLock from '../../hooks/useWakeLock';
import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import Button from '../../incase-domain/components/button/Button';
import {currentSlideIndexSelector, loadedPresentationSelector, visibleSlideSelector} from '../../store/selectors/presentation.selectors';
import {pointsSelector} from '../../store/selectors/runfile.selectors';
import SlideSwiper from '../../ui/components/SlideSwiper.js';
import {useCurrentMobileQuestion} from '../../util/useCurrentMobileQuestion';
import Slide from '../slide/slide';
import EndPresentationModal from '../widget/EndPresentationModal';
import Timer from '../widget/timer';
import MobileFooter from './parts/components/MobileFooter';
import {SlideModal} from './parts/components/SlideModal';
import {QuestionAnswerHeader} from './parts/components/QuestionAnswerHeader';
import {useSlideBackground} from '../../hooks/useSlideBackground';

export function PresentationViewMobile(): JSX.Element {
    const {t} = useTranslation();

    useWakeLock();

    const currentSlideIndex = useSelector(currentSlideIndexSelector);
    const visibleSlides = useSelector(visibleSlideSelector);

    const points = useSelector(pointsSelector);

    const activeQuestion = useCurrentMobileQuestion();

    const loadedPresentation = useSelector(loadedPresentationSelector);
    const currentSlide = visibleSlides?.[currentSlideIndex];
    const {effectiveBackgroundColor, effectiveBackgroundImage} = useSlideBackground(loadedPresentation, DeviceType.MOBILE, currentSlide);

    function getSlideStyles(): React.CSSProperties {
        return {
            backgroundColor: effectiveBackgroundColor,
            ...(effectiveBackgroundImage && {
                backgroundImage: `url('${effectiveBackgroundImage}')`,
                backgroundSize: '100% 100%',
            }),
        };
    }

    return (
        <>
            <QuestionAnswerHeader />

            <div className="p-player__mobile">
                <SlideSwiper>
                    <div className="p-player__mobile_body" style={{...getSlideStyles(), fontSize: '17px'}}>
                        <div className="c-slideInfo">
                            <Button
                                variant="soft"
                                color="primary"
                                size="md"
                                padded={false}
                                disablePointerEvents
                                className="c-slideInfo__tag"
                            >
                                {currentSlideIndex + 1}
                            </Button>
                            <div className="c-slideInfo__chip">
                                <Button variant="ghost" size="md" leading="solar:clock-circle-linear" disablePointerEvents>
                                    <Timer />
                                </Button>
                                <Button leading="solar:cup-outline" variant="ghost" size="md" disablePointerEvents>
                                    {t('header.points', {count: points})}
                                </Button>
                            </div>
                        </div>

                        {currentSlide && <Slide key={currentSlide._id} device={DeviceType.MOBILE} slide={currentSlide} />}
                    </div>
                </SlideSwiper>

                <MobileFooter currentQuestion={activeQuestion} />

                <SlideModal device={DeviceType.MOBILE} />
            </div>

            <EndPresentationModal />
        </>
    );
}
